"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _logo = _interopRequireDefault(require("./img/logo.svg"));
var _styles = _interopRequireDefault(require("./styles"));
const Logo = props => {
  const {
    src,
    href,
    classes: propsClasses
  } = props;
  const classes = (0, _styles.default)();
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    className: propsClasses.link
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: `${classes.logo} ${propsClasses.logo}`,
    src: src,
    alt: "logo"
  }));
};
Logo.defaultProps = {
  src: _logo.default,
  href: "/",
  alt: "Совкомбанк",
  classes: {
    link: "",
    logo: ""
  }
};
var _default = Logo;
exports.default = _default;